"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[62366],{

/***/ 15740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RegisterTradingModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(579);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37213);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29658);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48085);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38305);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41110);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70175);











function RegisterTradingModal(param) {
    var visible = param.visible, onClose = param.onClose;
    var closeModal = (0,_store__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(state) {
        return state.closeModal;
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false), loading = ref[0], setloading = ref[1];
    var handleClose = function() {
        closeModal();
        if (onClose) {
            onClose();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_6__/* .AuthModalContainer */ .EB, {
        "data-cy": "register-trading-modal",
        visible: visible,
        centered: true,
        width: 751,
        onCancel: handleClose,
        zIndex: 1050,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_6__/* .CarouselContainer */ .am, {
                    justify: "center",
                    align: "center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_7__/* .Carousel */ .lr, {})
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_6__/* .RegisterInfoContainer */ .un, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            condition: loading,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_7__/* .AuthModalLoading */ .FL, {})
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            condition: !loading,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    family: "bold",
                                    size: "24px",
                                    mb: "8px",
                                    children: "Mulai Investasi di Saham bersama Stockbit"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    mb: "40px",
                                    children: "Download aplikasi Stockbit untuk membuka akun trading dan mulai perjalanan investasimu dengan lebih mudah. Scan QR Code di bawah ini."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    justify: "space-between",
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            direction: "column",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    target: "_blank",
                                                    href: constants_api__WEBPACK_IMPORTED_MODULE_4__/* .GOOGLE_PLAY_URL */ .VE,
                                                    rel: "noopener noreferrer",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                        alt: "android",
                                                        src: "/images/google-play.png",
                                                        style: {
                                                            height: "40px",
                                                            marginBottom: "24px"
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    target: "_blank",
                                                    href: constants_api__WEBPACK_IMPORTED_MODULE_4__/* .APP_STORE_URL */ .l5,
                                                    rel: "noopener noreferrer",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                        alt: "iOS",
                                                        src: "/images/app-store.png",
                                                        style: {
                                                            height: "40px"
                                                        }
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_6__/* .RegisterInfoDivider */ .kp, {}),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            src: "/img/stockbit-qr.svg",
                                            alt: "stockbit app qr code"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    justify: "space-between",
                                    align: "center",
                                    mt: "40px",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                            size: "16px",
                                            color: "#858585",
                                            children: "Or Switch Platform"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_7__/* .VirtualTradingButton */ .qW, {
                                            title: "Virtual Trading",
                                            type: _types__WEBPACK_IMPORTED_MODULE_8__/* .AuthModalType.REGISTER */ .O.REGISTER,
                                            setLoading: setloading
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 62366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ AuthModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/global/Securities/stores/useOpeningAccountStore.ts
var useOpeningAccountStore = __webpack_require__(8948);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/lib/stores/trading.ts
var trading = __webpack_require__(76260);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/lib/analytics/securities.ts
var securities = __webpack_require__(91154);
// EXTERNAL MODULE: ./src/features/securities/AuthModal/styled.ts
var styled = __webpack_require__(48085);
// EXTERNAL MODULE: ./src/features/securities/AuthModal/components/index.tsx + 7 modules
var components = __webpack_require__(38305);
// EXTERNAL MODULE: ./src/features/securities/AuthModal/types.ts
var types = __webpack_require__(41110);
// EXTERNAL MODULE: ./src/features/securities/AuthModal/store.ts
var store = __webpack_require__(70175);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/constants/trading.ts
var constants_trading = __webpack_require__(83153);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/lib/stores/tradingData.ts + 1 modules
var tradingData = __webpack_require__(36902);
// EXTERNAL MODULE: ./src/lib/stores/multiPorto.ts
var multiPorto = __webpack_require__(34385);
// EXTERNAL MODULE: ./src/global/TradingModal/store.ts
var TradingModal_store = __webpack_require__(70362);
// EXTERNAL MODULE: ./src/global/Securities/stores/useSecuritiesCredentialStore.ts + 1 modules
var useSecuritiesCredentialStore = __webpack_require__(71158);
// EXTERNAL MODULE: ./src/features/multi-porto/stores/modal.store.ts
var modal_store = __webpack_require__(3683);
// EXTERNAL MODULE: ./src/lib/flipt/store/useFliptStore.ts + 4 modules
var useFliptStore = __webpack_require__(90060);
// EXTERNAL MODULE: ./src/lib/flipt/constants/flagKeys.ts
var flagKeys = __webpack_require__(34540);
// EXTERNAL MODULE: ./src/stores/useUIConfigStore/index.ts + 1 modules
var useUIConfigStore = __webpack_require__(7639);
// EXTERNAL MODULE: ./src/typings/auth.ts
var auth = __webpack_require__(97718);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 1 modules
var es_message = __webpack_require__(12461);
// EXTERNAL MODULE: ./src/features/securities/AuthModal/constants.ts
var constants = __webpack_require__(54855);
// EXTERNAL MODULE: ./src/features/securities/utils.tsx
var utils = __webpack_require__(4621);
;// CONCATENATED MODULE: ./src/features/securities/AuthModal/hooks/useLogin.ts
























var useTradingStore = (0,esm/* default */.ZP)(trading/* default */.Z);
function useLogin() {
    var resetErrorCode = useTradingStore().resetErrorCode;
    var getConfigFormula = (0,tradingData/* default */.Z)().getConfigFormula;
    var showTradingModal = (0,TradingModal_store/* default */.Z)(function(state) {
        return state.showModal;
    });
    var ref = (0,store/* default */.Z)(), closeModal = ref.closeModal, tradingModalConfig = ref.tradingModalConfig;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useSecuritiesCredentialStore/* default */.Z)(function(s) {
        return [
            s.loadLoginReal,
            s.loadLogout
        ];
    }, shallow/* default */.Z), 2), loadLoginReal = ref1[0], loadLogout = ref1[1];
    var loadBooleanEvaluation = (0,useFliptStore/* default */.Z)(function(s) {
        return s.loadBooleanEvaluation;
    });
    var getUIValue = (0,useUIConfigStore/* default */.Z)(function(s) {
        return s.getUIValue;
    });
    var resetUIValue = (0,useUIConfigStore/* default */.Z)(function(s) {
        return s.resetUIValue;
    });
    var setModal = (0,modal_store/* default */.Z)(function(s) {
        return s.openModal;
    });
    var getSubAccounts = (0,multiPorto/* default */.Z)(function(s) {
        return s.getSubAccounts;
    });
    var ref2 = (0,react.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var ref3 = (0,react.useState)(""), errorMsg = ref3[0], setErrorMsg = ref3[1];
    var handleErrorNewCore = function(error) {
        var ref;
        var ref1, ref2;
        var ref3 = (ref2 = (ref1 = error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : ref.data) !== null && ref1 !== void 0 ? ref1 : error === null || error === void 0 ? void 0 : error.cause) !== null && ref2 !== void 0 ? ref2 : {}, errorType = ref3.error_type, message = ref3.message;
        if (errorType === "INVALID_CREDS") {
            setErrorMsg(message);
        }
        if (errorType !== "INVALID_CREDS") {
            closeModal();
        }
    };
    var handleErrorLegacy = function(message) {
        if (message) {
            setErrorMsg(message);
        }
        if (!message) {
            closeModal();
        }
    };
    var checkDailyMaintenance = function() {
        return trading/* default.getState */.Z.getState().errorType === "DAILY_MAINTENANCE_MODE";
    };
    var onLogin = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(pin) {
            var isDailyMaintenance, SPLIT_ORDER, can_create_new_sub_account, sub_accounts, ref, ref1, ref2, isOnboardingMultiPortoShown, showOnboardingBasedOnList, ref3, message, isUserNewCore;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.prev = 1;
                        // Reset UI value because didn't reset when user logged out not from logout button
                        resetUIValue(auth/* LoginType.Securities */.B.Securities);
                        _ctx.next = 5;
                        return loadLoginReal(pin);
                    case 5:
                        isDailyMaintenance = checkDailyMaintenance();
                        if (!isDailyMaintenance) {
                            _ctx.next = 10;
                            break;
                        }
                        {
                            loadLogout();
                        }
                        _ctx.next = 43;
                        break;
                    case 10:
                        SPLIT_ORDER = flagKeys/* FeatureFlagKeys.SPLIT_ORDER */.O.SPLIT_ORDER;
                        _ctx.next = 13;
                        return getConfigFormula();
                    case 13:
                        _ctx.next = 15;
                        return loadBooleanEvaluation(SPLIT_ORDER);
                    case 15:
                        setErrorMsg("");
                        resetErrorCode();
                        (0,AlertErrorMessage/* default */.Z)("Kamu berhasil masuk ke Akun Trading", "plain-green");
                        can_create_new_sub_account = false;
                        sub_accounts = [];
                        _ctx.prev = 20;
                        ;
                        _ctx.next = 24;
                        return getSubAccounts();
                    case 24:
                        ref = _ctx.sent;
                        ref1 = ref.can_create_new_sub_account;
                        can_create_new_sub_account = ref1 === void 0 ? false : ref1;
                        ref2 = ref.sub_accounts;
                        sub_accounts = ref2 === void 0 ? [] : ref2;
                        ref;
                        _ctx.next = 35;
                        break;
                    case 32:
                        _ctx.prev = 32;
                        _ctx.t0 = _ctx["catch"](20);
                        ;
                    case 35:
                        isOnboardingMultiPortoShown = getUIValue("multiPortfolioOnboardingEligible");
                        showOnboardingBasedOnList = can_create_new_sub_account && sub_accounts.length <= 1;
                        if (!(showOnboardingBasedOnList && !isOnboardingMultiPortoShown && (tradingModalConfig === null || tradingModalConfig === void 0 ? void 0 : tradingModalConfig.entryPoint) === "btn-trading")) {
                            _ctx.next = 41;
                            break;
                        }
                        closeModal();
                        setModal(modal_store/* ModalNames.PORTFOLIO_ONBOARDING */.s.PORTFOLIO_ONBOARDING);
                        return _ctx.abrupt("return");
                    case 41:
                        if (tradingModalConfig !== null && !tradingModalConfig.onRealLoginSuccess) {
                            showTradingModal((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tradingModalConfig), {
                                orderType: constants/* AUTH_MODAL_CONFIG.real */.n.real[tradingModalConfig.orderType]
                            }));
                        }
                        if (tradingModalConfig === null || tradingModalConfig === void 0 ? void 0 : tradingModalConfig.onRealLoginSuccess) {
                            tradingModalConfig.onRealLoginSuccess();
                        }
                    case 43:
                        closeModal();
                        _ctx.next = 53;
                        break;
                    case 46:
                        _ctx.prev = 46;
                        _ctx.t1 = _ctx["catch"](1);
                        // Specific case, due to existing issue on code that isShowAlertMessage not developed properly
                        // We cannot handle isShowAlertMessage, because the requestConfigTrading is used widely
                        // need to reconfirm to all api that use requestConfigTrading
                        es_message/* default.destroy */.ZP.destroy();
                        ;
                        message = ((ref3 = _ctx.t1 === null || _ctx.t1 === void 0 ? void 0 : _ctx.t1.cause) !== null && ref3 !== void 0 ? ref3 : {}).message;
                        isUserNewCore = (0,utils/* getTargetAPI */.Ai)() === constants_trading/* UserTargetAPI.NEW_CORE */.FA.NEW_CORE;
                        if (!isUserNewCore) {
                            handleErrorLegacy(message);
                        } else {
                            handleErrorNewCore(_ctx.t1);
                        }
                    case 53:
                        setLoading(false);
                    case 54:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    46
                ],
                [
                    20,
                    32
                ]
            ]);
        }));
        return function onLogin(pin) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        loading: loading,
        setLoading: setLoading,
        errorMsg: errorMsg,
        setErrorMsg: setErrorMsg,
        onLogin: onLogin
    };
};

;// CONCATENATED MODULE: ./src/features/securities/AuthModal/LoginTradingModal.tsx
















var LoginTradingModal_useTradingStore = (0,esm/* default */.ZP)(trading/* default */.Z);
function LoginTradingModal(param) {
    var visible = param.visible;
    var resetErrorCode = LoginTradingModal_useTradingStore().resetErrorCode;
    var closeModal = (0,store/* default */.Z)().closeModal;
    var ref = (0,react.useState)(""), pin = ref[0], setPIN = ref[1];
    var ref1 = useLogin(), errorMsg = ref1.errorMsg, setErrorMsg = ref1.setErrorMsg, loading = ref1.loading, setLoading = ref1.setLoading, onLogin = ref1.onLogin;
    var closeLoginModal = function() {
        resetErrorCode();
        setErrorMsg("");
        closeModal();
    };
    (0,react.useEffect)(function() {
        setErrorMsg("");
        if (visible) {
            (0,securities/* clevertapSecuritiesTradingPinViewed */.fn)();
        }
    }, [
        visible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* LoginTradingModalContainer */.Ue, {
        "data-cy": "login-trading-modal",
        visible: visible,
        centered: true,
        width: 500,
        onCancel: closeLoginModal,
        transitionName: "custom-modal",
        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: "icon/close-modal.svg"
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            direction: "column",
            justify: "center",
            align: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    className: "illustration",
                    alt: "securities-lock",
                    src: "icon/pinlogin-lock.svg"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: loading,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* AuthModalLoading */.FL, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                    condition: !loading,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            size: "18px",
                            family: "bold",
                            mt: "16px",
                            mb: "32px",
                            children: "Input Trading PIN"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* LoginInputPin */.WR, {
                            onChangePIN: setPIN,
                            errorMsg: errorMsg,
                            onPressEnter: function(pinValue) {
                                return onLogin(pinValue);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/securities/forgotpin",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                onClick: closeLoginModal,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    size: "14px",
                                    family: "bold",
                                    color: color/* default.primary */.Z.primary,
                                    // @ts-expect-error
                                    p: "10.5px",
                                    mt: "8px",
                                    mb: "16px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        "data-cy": "auth-modal-forgot-pin",
                                        children: "Forgot PIN?"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            width: "100%",
                            justify: "center",
                            padding: "20px 0 24px 0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ButtonSubmit */.GX, {
                                onClick: function() {
                                    onLogin(pin);
                                    (0,securities/* clevertapSecuritiesTradingPinSubmitted */.FH)();
                                },
                                disabled: pin.length < 6,
                                children: "Submit"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            width: "100%",
                            justify: "space-between",
                            align: "center",
                            mb: "26px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* LoginInfoDivider */.rG, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    family: "bold",
                                    color: color/* default.midgray */.Z.midgray,
                                    children: "Or"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* LoginInfoDivider */.rG, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* VirtualTradingButton */.qW, {
                            title: "Virtual Trading",
                            type: types/* AuthModalType.LOGIN */.O.LOGIN,
                            setLoading: setLoading
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/features/securities/AuthModal/ProgressAuthModal.tsx










function ProgressAuthModal(param) {
    var visible = param.visible;
    var closeModal = (0,store/* default */.Z)(function(state) {
        return state.closeModal;
    });
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ProgressRejectedAuthModalContainer */.X4, {
        "data-cy": "progress-auth-modal",
        visible: visible,
        centered: true,
        width: 500,
        onCancel: closeModal,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: loading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* AuthModalLoading */.FL, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                condition: !loading,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "/img/auth-progress.svg",
                        alt: "Registrasi Kamu Dalam Proses"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        align: "center",
                        family: "bold",
                        size: "16px",
                        mt: "30px",
                        mb: "13px",
                        children: "Registrasi Kamu Dalam Proses"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        align: "center",
                        mb: "30px",
                        color: color/* default.highgray */.Z.highgray,
                        width: "284px",
                        children: "Mohon ditunggu sebentar lagi. Registrasi kamu masih dalam tahap verifikasi."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* VirtualTradingButton */.qW, {
                        title: "Coba Virtual Trading",
                        type: types/* AuthModalType.PROGRESS */.O.PROGRESS,
                        setLoading: setLoading
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/features/securities/AuthModal/RegisterTradingModal.tsx
var RegisterTradingModal = __webpack_require__(15740);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
;// CONCATENATED MODULE: ./src/features/securities/AuthModal/RejectedAuthModal.tsx








function RejectedAuthModal(param) {
    var visible = param.visible;
    var closeModal = (0,store/* default */.Z)(function(state) {
        return state.closeModal;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ProgressRejectedAuthModalContainer */.X4, {
        "data-cy": "rejected-auth-modal",
        visible: visible,
        centered: true,
        width: 364,
        onCancel: closeModal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            direction: "column",
            justify: "center",
            align: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/img/stockbit-qr.svg",
                    alt: "stockbit app qr code"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    align: "center",
                    mt: "2px",
                    mb: "30px",
                    children: "Scan QR Code"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    family: "bold",
                    size: "16px",
                    align: "center",
                    mb: "13px",
                    children: "Verifikasi Data Belum Berhasil"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    align: "center",
                    mb: "30px",
                    color: color/* default.highgray */.Z.highgray,
                    children: "Silakan scan QR Code di atas atau buka aplikasi Stockbit kamu dan perbaiki data sesuai dengan instruksi."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    type: "primary",
                    width: "100%",
                    radius: "4px",
                    onClick: closeModal,
                    "data-cy": "rejected-auth-modal-btn",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        family: "bold",
                        color: color/* default.light */.Z.light,
                        padding: "12px",
                        children: "Oke"
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/features/securities/AuthModal/index.tsx












function AuthModal() {
    var authModalVisible = (0,store/* default */.Z)(function(s) {
        return s.visible;
    });
    var ref = (0,_sliced_to_array/* default */.Z)((0,useOpeningAccountStore/* default */.Z)(function(s) {
        return [
            s.status,
            s.loadAccountStatus
        ];
    }, shallow/* default */.Z), 2), oaStatus = ref[0], loadAccountStatus = ref[1];
    (0,react.useEffect)(function() {
        loadAccountStatus();
    }, [
        loadAccountStatus
    ]);
    var accountNotRegistered = [
        types/* AuthModalStatus.UNREGISTERED */.X.UNREGISTERED,
        types/* AuthModalStatus.INCOMPLETE */.X.INCOMPLETE, 
    ].includes(oaStatus);
    var accountOnProgress = [
        types/* AuthModalStatus.CS */.X.CS,
        types/* AuthModalStatus.KSEI */.X.KSEI,
        types/* AuthModalStatus.RDN */.X.RDN, 
    ].includes(oaStatus);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
        condition: authModalVisible,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: accountNotRegistered,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterTradingModal/* default */.Z, {
                    visible: accountNotRegistered
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: accountOnProgress,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressAuthModal, {
                    visible: accountOnProgress
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: oaStatus === types/* AuthModalStatus.REJECTED */.X.REJECTED,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RejectedAuthModal, {
                    visible: oaStatus === types/* AuthModalStatus.REJECTED */.X.REJECTED
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: oaStatus === types/* AuthModalStatus.COMPLETED */.X.COMPLETED,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginTradingModal, {
                    visible: oaStatus === types/* AuthModalStatus.COMPLETED */.X.COMPLETED
                })
            })
        ]
    });
};


/***/ }),

/***/ 48085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EB": function() { return /* binding */ AuthModalContainer; },
/* harmony export */   "GX": function() { return /* binding */ ButtonSubmit; },
/* harmony export */   "Ue": function() { return /* binding */ LoginTradingModalContainer; },
/* harmony export */   "X4": function() { return /* binding */ ProgressRejectedAuthModalContainer; },
/* harmony export */   "am": function() { return /* binding */ CarouselContainer; },
/* harmony export */   "kp": function() { return /* binding */ RegisterInfoDivider; },
/* harmony export */   "rG": function() { return /* binding */ LoginInfoDivider; },
/* harmony export */   "un": function() { return /* binding */ RegisterInfoContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16368);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    border-radius: 3px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-body {\n    padding: 40px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-body {\n    padding: 40px 40px 20px 40px;\n  }\n\n  /* Fade In & Scale Up Animation */\n  @keyframes fadeScaleIn {\n    from {\n      opacity: 0;\n      transform: scale(0.8);\n    }\n    to {\n      opacity: 1;\n      transform: scale(1);\n    }\n  }\n\n  /* Fade Out & Scale Down Animation */\n  @keyframes fadeScaleOut {\n    from {\n      opacity: 1;\n      transform: scale(1);\n    }\n    to {\n      opacity: 0;\n      transform: scale(0.8);\n    }\n  }\n\n  /* Ant Design Modal Animation Overrides */\n  .custom-modal-enter {\n    animation: fadeScaleIn 0.5s ease-out;\n  }\n\n  .custom-modal-leave {\n    animation: fadeScaleOut 0.5s ease-in;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 360px;\n  min-height: 492px;\n  background-color: #5dcbad26;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 391px;\n  padding: 40px 32px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 1px;\n  height: 144px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 185px;\n  height: 1px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 160px;\n  height: 40px;\n  gap: 10px;\n  padding-top: 10px;\n  padding-right: 20px;\n  padding-bottom: 10px;\n  padding-left: 20px;\n  border-radius: 4px;\n  background: #00AB6B;\n  border: none;\n  color: #FFF;\n  font-family: var(--font-bold);\n  cursor: pointer;\n\n  :disabled {\n    background: #CCEEE1;\n    cursor: not-allowed;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}




var AuthModalContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-ab604be6-0"
})(_templateObject());
var ProgressRejectedAuthModalContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(AuthModalContainer).withConfig({
    componentId: "sc-ab604be6-1"
})(_templateObject1());
var LoginTradingModalContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(AuthModalContainer).withConfig({
    componentId: "sc-ab604be6-2"
})(_templateObject2());
var CarouselContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-ab604be6-3"
})(_templateObject3());
var RegisterInfoContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ab604be6-4"
})(_templateObject4());
var RegisterInfoDivider = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ab604be6-5"
})(_templateObject5(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].downgray */ .Z.downgray);
var LoginInfoDivider = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ab604be6-6"
})(_templateObject6(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].downgray */ .Z.downgray);
var ButtonSubmit = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-ab604be6-7"
})(_templateObject7());


/***/ })

}]);